import { RAGStatuses } from '../../shared/enums/ragStatuses';

export class RAGUpdate {
  public projectId: number;
  public taskId: number;
  public ragStatus: RAGStatuses;
  public comment: string;
}
